/* @generated */

// src/assets/ui-icon/line/task-queue.tsx
import * as React from "react";
var TaskQueueLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 4.5V6H7v2.085c.03 1.805.49 3.015 1.275 3.77.153.147.323.281.51.402a3.378 3.378 0 0 0-.645.518c-.685.715-1.09 1.785-1.14 3.32V18.5H5.5V20h13v-1.5H17v-2.085c-.03-1.805-.49-3.015-1.275-3.77a3.366 3.366 0 0 0-.51-.402c.244-.152.459-.325.645-.518.685-.715 1.09-1.785 1.14-3.32V6h1.5V4.5h-13Zm6.575 7h-.165c-1.22 0-2.095-.245-2.595-.725-.52-.5-.795-1.41-.815-2.69V6h7v2.38c-.04 1.07-.28 1.845-.72 2.3-.5.515-1.41.79-2.705.82ZM9.22 13.82c.5-.515 1.41-.79 2.705-.82h.165c1.22 0 2.095.245 2.595.725.462.444.73 1.212.799 2.275H8.505c.053-1.008.292-1.742.715-2.18Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  TaskQueueLine
};
